import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaSpinner } from 'react-icons/fa';
import { cities } from '../data/cities';
import '../styles/SearchBar.css';

const SearchBar: React.FC = () => {
  const [query, setQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredCities, setFilteredCities] = useState(cities);
  const searchRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (searchRef.current && !searchRef.current.contains(event.target as Node)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSearch = (searchQuery: string) => {
    setQuery(searchQuery);
    setIsLoading(true);
    setShowDropdown(true);

    // Simulate API call with setTimeout
    setTimeout(() => {
      const filtered = cities.filter(city =>
        city.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        city.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        city.attractions.some(attr => 
          attr.toLowerCase().includes(searchQuery.toLowerCase())
        )
      );
      setFilteredCities(filtered);
      setIsLoading(false);
    }, 500); // 500ms delay to show loading animation
  };

  const handleCityClick = (cityId: string) => {
    setShowDropdown(false);
    setQuery('');
    navigate(`/city/${cityId}`);
  };

  return (
    <div className="search-container" ref={searchRef}>
      <div className="search-input-container">
        <FaSearch className="search-icon" />
        <input
          type="text"
          placeholder="Search for cities, attractions, or experiences..."
          value={query}
          onChange={(e) => handleSearch(e.target.value)}
          className="search-input"
        />
        {isLoading && <FaSpinner className="loading-icon spin" />}
      </div>
      
      {showDropdown && query && (
        <div className="search-dropdown">
          {filteredCities.length > 0 ? (
            filteredCities.map(city => (
              <div
                key={city.id}
                className="dropdown-item"
                onClick={() => handleCityClick(city.id)}
              >
                <div className="dropdown-item-content">
                  <img src={city.image} alt={city.name} className="dropdown-image" />
                  <div className="dropdown-text">
                    <h3>{city.name}</h3>
                    <p>{city.description.substring(0, 100)}...</p>
                    <div className="dropdown-attractions">
                      {city.attractions.slice(0, 3).map((attr, index) => (
                        <span key={index} className="attraction-tag">
                          {attr}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              No cities found matching your search
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchBar;